<template>

    <div id="content" role="main">

      <div class="row mt-5">
        <div class="col-md-12">
          <div class="content_title">
            <h1>{{ $t('message.benachrichtigungen_h1') }}</h1>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-5">

        <div v-if="$store.getters.user_role.authority == ROLE_KEY_USER || $store.getters.anzahlCustomer > 1">

          <!-- bei einem User auswählen ob er über neue Standorte verständigt werden soll -->
          <h2 class="text-left">{{ $t('message.benachrichtigungen_vertragszuteilung') }}:</h2>
          <disable-notification-neuer-vertrag :customer="ALLE" />

          <hr class="mb-5" />

        </div>

        <!-- entweder global setzen, oder individuell -->
        <div v-if="$store.getters.anzahlCustomer > 1">
          <b-button-group class="mb-3">
            <b-button :variant="hasGlobalNotifications ? 'success' : 'outline-secondary'"
                      @click="setHasGlobalNotifications(true)">
              {{ $t('message.benachrichtigungen_global') }}
            </b-button>
            <b-button :variant="!hasGlobalNotifications ? 'success' : 'outline-secondary'"
                      @click="setHasGlobalNotifications(false)">
              {{ $t('message.benachrichtigungen_global_nein') }}
            </b-button>
          </b-button-group>
        </div>
        <div v-if="$store.getters.anzahlCustomer > 1 && hasGlobalNotifications">

          <b-alert show>

            {{ $t('message.benachrichtigungen_global_desc') }}

            <div class="description mb-3 mt-3">

              <div class="row">
                <div class="col-md-12">
                  <b-button size="sm" variant="success" id="alleAktiv">
                    <b-icon icon="check-circle-fill"></b-icon>
                  </b-button>
                  &nbsp;
                  <label for="alleAktiv">{{ $t('message.customerNotifications_fuer_alle_desc') }}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <b-button size="sm" variant="danger" id="alleDeaktiv">
                    <b-icon icon="dash-circle-fill"></b-icon>
                  </b-button>
                  &nbsp;
                  <label for="alleDeaktiv">{{ $t('message.customerNotifications_fuer_alle_inaktiv_desc') }}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <b-button size="sm" variant="primary" id="andereAktiv">
                    <b-icon icon="sliders"></b-icon>
                  </b-button>
                  &nbsp;
                  <label for="andereAktiv">{{ $t('message.customerNotifications_fuer_andere_desc') }}</label>
                </div>
              </div>

            </div>

          </b-alert>

          <div class="card">
            <div class="card-body">

              <!-- Besuchsbericht Verständigungen -->
              <h3 class="text-left">{{ $t('message.benachrichtigungen_besuchsbericht_meldungen') }}:</h3>
              <p class="notification-section-hint">
                <b-icon icon="info-circle"></b-icon>
                {{ $t('message.benachrichtigungen_besuchsbericht_meldungen_desc') }}
              </p>
              <p>{{ $t('message.benachrichtigungen_konf2') }}:</p>
              <disable-notification-neuer-besuchsbericht
                  :customer="ALLE"
                  :label="$t('message.benachrichtigungen_label')"
                  :label-app="$t('message.benachrichtigungen_label_app')"
              />
              <notification-neuer-mangel :customer="ALLE" />
              <notification-alarm :customer="ALLE" />

              <hr class="mt-3 mb-5" />

              <!-- Traplinked Verständigungen -->
              <h3 class="text-left">{{ $t('message.benachrichtigungen_247_meldungen') }}:</h3>
              <p class="notification-section-hint">
                <b-icon icon="info-circle"></b-icon>
                {{ $t('message.benachrichtigungen_247_meldungen_desc') }}
              </p>
              <traplinked-notifications :customer="ALLE" />

            </div>
          </div>

        </div>

        <!-- bei individuell pro Standort, für Alle übernehmen aktivieren/deaktivieren -->
        <div class="row mb-3" v-if="!hasGlobalNotifications && $store.getters.anzahlCustomer > 1">
          <div class="col-md-6">

            <b-button
                variant="outline-info"
                id="activate_all"
                class="mt-1 mr-2"
                size="sm"
                @click="setAllEmailNotificationActive()">
              <b-icon icon="check-square"></b-icon> {{ $t('message.benachrichtigungen_alle_on') }}
            </b-button>

            <b-button
                variant="outline-warning"
                size="sm"
                class="mt-1 mr-2"
                id="deactivate_all"
                @click="setAllEmailNotificationInactive()"
                name="deactivate_all">
              <b-icon icon="square"></b-icon> {{ $t('message.benachrichtigungen_alle_off') }}
            </b-button>

          </div>
          <div class="col-md-6">

            <b-button
                variant="outline-info"
                class="mt-1 mr-2"
                size="sm"
                id="activate_all_app"
                @click="setAllAppNotificationActive()"
                name="activate_all_app">
              <b-icon icon="check-square"></b-icon> {{ $t('message.benachrichtigungen_alle_app_on') }}
            </b-button>

            <b-button
                variant="outline-warning"
                class="mt-1 mr-2"
                size="sm"
                id="deactivate_all_app"
                @click="setAllAppNotificationInactive()"
                name="deactivate_all_app">
              <b-icon icon="square"></b-icon> {{ $t('message.benachrichtigungen_alle_app_off') }}
            </b-button>

          </div>
        </div>

        <span v-if="$store.getters.anzahlCustomer > 1 && hasGlobalNotifications == false">

          <div class="card">
            <div class="card-body">

                <!-- bei einem KeyUser alle Standorte auflisten oder wenn ein User mehrere Standorte zugewiesen hat -->
                <h2 class="text-left">{{ $t('message.benachrichtigungen_mailVerstaendigung') }}:</h2>
                <customer-list :show-details="false"
                               :number-per-page="20"
                               :benutzer="$store.getters.user"
                               :action="'DISABLE-NOTIFICATIONS'"
                               :logged-in-user="$store.getters.user"
                               v-on:selected-customers="setSelectedCustomers"
                />

            </div>
          </div>

        </span>

        <!-- bei einem Benutzer mit einem Standort nur Checkboxen anzeigen -->
        <span v-else-if="$store.getters.user_role.authority == ROLE_CUSTOMER || ($store.getters.user_role.authority == ROLE_KEY_USER && $store.getters.anzahlCustomer <= 1)">

          <!-- Besuchsbericht Verständigungen -->
          <span v-if="!hasGlobalNotifications">

            <!-- bei einem User auswählen ob er über neue Standort verständigt werden soll -->
            <h2 class="text-left mt-3">{{ $t('message.benachrichtigungen_mailVerstaendigung') }}:</h2>
            <p>{{ $t('message.benachrichtigungen_konf') }}:</p>
            <disable-notification-neuer-vertrag :customer="$store.getters.customer" />

            <hr class="mt-3 mb-3" />

            <h2 class="text-left">{{ $t('message.benachrichtigungen_besuchsbericht_meldungen') }}:</h2>
            <p class="notification-section-hint">
              <b-icon icon="info-circle"></b-icon>
              {{ $t('message.benachrichtigungen_besuchsbericht_meldungen_desc') }}
            </p>
            <p>{{ $t('message.benachrichtigungen_konf2') }}:</p>
            <disable-notification-neuer-besuchsbericht :customer="$store.getters.customer"
                                                       :label="$t('message.benachrichtigungen_label')"
                                                       :label-app="$t('message.benachrichtigungen_label_app')"
            />
            <notification-neuer-mangel :customer="$store.getters.customer" />
            <notification-alarm :customer="$store.getters.customer" />

            <hr class="mt-3 mb-5" />

            <!-- Traplinked Verständigungen -->
            <h2 class="text-left">{{ $t('message.benachrichtigungen_247_meldungen') }}:</h2>
            <p class="notification-section-hint">
              <b-icon icon="info-circle"></b-icon>
              {{ $t('message.benachrichtigungen_247_meldungen_desc') }}
            </p>
            <traplinked-notifications :customer="$store.getters.customer" />

          </span>

        </span>


      </div>
    </div>

</template>

<script>

  import axios from 'axios'
  axios.defaults.withCredentials = true
  import DisableNotificationNeuerBesuchsbericht from '@/components/customer/DisableNotificationNeuerBesuchsbericht'
  import DisableNotificationNeuerVertrag from '@/components/customer/DisableNotificationNeuerVertrag'
  import TraplinkedNotifications from '@/components/customer/TraplinkedNotifications'
  import NotificationAlarm from '@/components/customer/NotificationAlarm'
  import NotificationNeuerMangel from '@/components/customer/NotificationNeuerMangel'
  import bootbox from 'bootbox'

  export default {
    name: 'Benachrichtigungen',
    components: {
      DisableNotificationNeuerBesuchsbericht,
      DisableNotificationNeuerVertrag,
      TraplinkedNotifications,
      NotificationAlarm,
      NotificationNeuerMangel,
    },
    data () {
      return {
        /** Kunden die von KeyUser ausgewählt wurden um keine Verständigung zu erhalten */
        selectedCustomers: null,
        ALLE: {
          id: 'ALLE',
          cardcode: 'ALLE',
          biotechCountry: { name: null },
        },
        hasGlobalNotifications: null,
      }
    },
    mounted () {
      // Umami Tracking aufrufen
      this.doTracking(this.$route.name)
      this.init()
    },
    methods: {

      /**
       * Notification global setzen oder pro Standort
       */
      setHasGlobalNotifications: function (val) {

        console.log('setHasGlobalNotifications', val)
        this.hasGlobalNotifications = val

        const url = process.env.VUE_APP_SERVER_URL + '/notification/setGlobalNotifications';
        axios({
          method: 'GET',
          params: {
            biotechUser_id: this.$store.getters.user.id,
            hasGlobalNotifications: val,
          },
          url: url
        })

      },
      init: function () {

        if (this.$store.getters.anzahlCustomer > 1) {

          const that = this
          that.hasGlobalNotifications = null
          const url = process.env.VUE_APP_SERVER_URL + '/notification/hasGlobalNotifications'
          axios({
            method: 'GET',
            params: {
              biotechUser_id: this.$store.getters.user.id,
            },
            url: url
          }).then( response => {

            that.hasGlobalNotifications = response.data.hasGlobalNotifications ? true : false

          }).catch(error => {
            console.log(error)
          })

        }

      },
      setAllEmailNotificationInactive: function () {

        const that = this
        const text = this.$t('message.benachrichtigungen_alle_off_confirm')
        bootbox.confirm(text, result => {
          if (result) {

            that.saveAllAppNotification (
                'setAllEmailNotificationInactive',
                that.$store.getters.allEmailNotificationInactive + 1
            )

          }
        })

      },
      /** E-Mail-Einstellungen für alle Standorte übernehmen */
      setAllEmailNotificationActive: function () {

        const that = this
        const text = this.$t('message.benachrichtigungen_alle_on_confirm')
        bootbox.confirm(text, result => {
          if (result) {

            that.saveAllAppNotification (
                'setAllEmailNotificationActive',
                that.$store.getters.allEmailNotificationActive + 1
            )

          }
        })

      },
      setAllAppNotificationInactive: function () {

        const that = this
        const text = this.$t('message.benachrichtigungen_alle_app_off_confirm')
        bootbox.confirm(text, result => {
          if (result) {

            that.saveAllAppNotification (
                'setAllAppNotificationInactive',
                that.$store.getters.allAppNotificationInactive + 1
            )

          }
        })

      },
      setAllAppNotificationActive: function () {

        const that = this
        const text = this.$t('message.benachrichtigungen_alle_app_on_confirm')
        bootbox.confirm(text, result => {
          if (result) {

            that.saveAllAppNotification (
                'setAllAppNotificationActive',
                that.$store.getters.allAppNotificationActive + 1
            )

          }
        })

      },
      saveAllAppNotification: function (type, count) {

        this.showSpinner();
        const url = process.env.VUE_APP_SERVER_URL + '/notification/saveAll'

        axios({
          method: 'GET',
          params: {
            type: type,
            biotechUser_id: this.$store.getters.user.id,
          },
          url: url
        }).then( () => {

          this.$store.commit(type, count)
          this.hideSpinner()
          console.log('Alle Notififation Ausnahme gespeichert.')

        }).catch(error => {
          console.log(error)
          this.hideSpinner()
        })

      },
      /**
       * Kunden die von KeyUser ausgewählt wurden um keine Verständigung zu erhalten
       */
      setSelectedCustomers: function (obj) {

        this.selectedCustomers = obj.selectedCustomers

      }

    }
  }

</script>

<style>
  /*
    Notification-Status-Badge: zeigt den aktuell gueltigen Zustand
    (aktiv / inaktiv / individuell) und ist nicht interaktiv. Click wird
    per Guard in der Komponente unterdrueckt, cursor: default signalisiert
    "nicht klickbar". Der farbige Ring hebt den Badge dezent vom Hintergrund ab.
    Der Badge ist bewusst vom rechts danebenliegenden Aktions-Buttongroup
    raeumlich getrennt.
  */
  .btn.notification-btn-status,
  .btn.notification-btn-status:hover,
  .btn.notification-btn-status:focus {
    cursor: default !important;
  }
  .btn.notification-btn-status.btn-success,
  .btn.notification-btn-status.btn-success:hover,
  .btn.notification-btn-status.btn-success:focus {
    box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.25);
  }
  .btn.notification-btn-status.btn-danger,
  .btn.notification-btn-status.btn-danger:hover,
  .btn.notification-btn-status.btn-danger:focus {
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25);
  }
  .btn.notification-btn-status.btn-primary,
  .btn.notification-btn-status.btn-primary:hover,
  .btn.notification-btn-status.btn-primary:focus {
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
  /*
    Feste Mindestbreiten fuer Status-Badge und Aktions-Gruppe, damit die
    Labels in jeder Zeile an derselben Position starten, unabhaengig davon
    ob der aktuelle Zustand "aktiviert", "deaktiviert" oder "individuell"
    lautet und wie viele Aktions-Buttons angezeigt werden.
  */
  .btn.notification-btn-status {
    min-width: 8rem;
    padding: 0 !important;
    overflow: hidden;
    display: inline-flex;
    align-items: stretch;
  }
  /* Split-Look: linker Teil zeigt das farbige Icon (Variant-Hintergrund),
     rechter Teil den Status-Text auf weissem Grund mit dunkler Schrift */
  .btn.notification-btn-status .notification-btn-status-icon {
    padding: 0.25rem 0.5rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .btn.notification-btn-status .notification-btn-status-label {
    background-color: #fff;
    color: #212529;
    padding: 0.25rem 0.75rem;
    display: inline-flex;
    align-items: center;
    flex-grow: 1;
  }
  .notification-btn-actions {
    min-width: 5rem;
  }
  /* Legenden-Box im Hinweis-Alert: weisser Hintergrund hebt die Icons
     und Texte vom eingefaerbten Alert ab und verbessert die Lesbarkeit. */
  .alert .description {
    background-color: #fff;
    padding: 1rem 1.25rem;
    border-radius: 0.25rem;
  }
  /* Kurzer Erklaertext unter den Benachrichtigungs-Ueberschriften
     (Besuchsbericht vs. Biotech247), dezent und ohne eigene Box. */
  .notification-section-hint {
    color: #6c757d;
    font-size: 0.9rem;
    margin-bottom: 0.75rem;
  }
  .notification-section-hint .b-icon {
    margin-right: 0.35rem;
    color: #17a2b8;
  }
</style>
